import { FooterHelp, Link } from '@shopify/polaris';

const PageFooter = ({ stripeBackground, helpLink, helpDescription }) => {
  return(
    <div style={{ 'borderBottom': `2px solid ${stripeBackground}` }}>
      <FooterHelp>
        Learn more about <Link url={`https://athousandapps.com/${helpLink}`} external>{ helpDescription }.</Link>
      </FooterHelp>
    </div>
  )
}

export default PageFooter;
